/**
 * Panel utility functions
 */

import { roleMap } from '../state.js';

/**
 * Populate the global roleMap with current role names
 */
export function populateRoleMap(roles: any[]): void {
    roleMap.clear();
    
    function addToMap(role: any) {
        if (role.id && role.name) {
            roleMap.set(role.id, role.name);
        }
        if (role.children && role.children.length > 0) {
            role.children.forEach(addToMap);
        }
    }
    
    roles.forEach(addToMap);
}

/**
 * Flatten nested role hierarchy into flat list
 */
export function flattenRoles(roles: any[] | any): any[] {
    const result: any[] = [];
    // Handle both array and single node
    const rolesArray = Array.isArray(roles) ? roles : [roles];
    
    function flatten(role: any) {
        result.push({ id: role.id, name: role.name });
        if (role.children && role.children.length > 0) {
            role.children.forEach(flatten);
        }
    }
    
    rolesArray.forEach(flatten);
    return result;
}

/**
 * Find a node by ID in the role hierarchy
 */
export function findNodeById(roles: any[] | any, id: number): any | null {
    // Handle both array and single node
    const rolesArray = Array.isArray(roles) ? roles : [roles];
    
    for (const role of rolesArray) {
        if (role.id === id) return role;
        if (role.children && role.children.length > 0) {
            const found = findNodeById(role.children, id);
            if (found) return found;
        }
    }
    return null;
}
